import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Clearfix, ListGroup, ListGroupItem } from 'react-bootstrap';
import moment from 'moment';
import PaymentModal from 'components/Pitch/PaymentModal';
import DeclinePitch from 'components/Pitch/DeclinePitch';
import Icon from 'components/Icon/Icon';
import InverseLabel from 'components/InverseLabel/InverseLabel';
import Linkify from 'components/Linkify/Linkify';
import Modal from 'components/Modal/Modal';
import AlertBox from 'components/AlertBox/AlertBox';
import Price from 'components/Price/Price';
import UserStatusBadges from 'components/Badges/UserStatusBadges/UserStatusBadges';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import TimeAgo from 'components/TimeAgo/TimeAgo';
import styles from './Pitch.module.scss';

export default class Pitch extends Component {
  static propTypes = {
    brief: PropTypes.object.isRequired,
    pitch: PropTypes.object.isRequired,
    onAccepted: PropTypes.func,
    onDeclined: PropTypes.func,
    acceptHireAB: PropTypes.string,
  };

  constructor() {
    super();

    this.state = {
      showAcceptPitch: false,
      showDeclinePitch: false,
      showContractModal: false,
      pitchTooLarge: false,
      fullPitch: false,
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.forceStateUpdate();
    }, 1000);

    this.checkPitchHeight();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  onAccept() {
    this.props.onAccepted(this.props.pitch);

    this.setState({
      showAcceptPitch: false,
    });
  }

  onDecline() {
    this.props.onDeclined(this.props.pitch);

    this.setState({
      showDeclinePitch: false,
    });
  }

  checkPitchHeight() {
    const pitchWrapper = document.getElementById(
      'pitchWrapper_' + this.props.pitch.id
    );

    this.setState({
      pitchTooLarge: pitchWrapper ? pitchWrapper.scrollHeight > 130 : false,
    });
  }

  showAcceptPitchModal() {
    this.setState({
      showAcceptPitch: true,
    });
  }

  static timer = null;

  forceStateUpdate() {
    this.setState({
      forceUpdate: this.state.forceUpdate > 9 ? 0 : this.state.forceUpdate + 1,
    });
  }

  humanReadableExpiry(expiry) {
    const diff = moment(expiry).diff(moment(), 'seconds');
    const secondsInDay = 86400;
    const secondsInHour = 3600;
    const secondsInMinute = 60;

    if (diff <= 0) {
      return (
        <InverseLabel color="#d9534f" bold>
          <Icon icon="&#xe614;" className="relative" style={{ top: '-1px' }} />{' '}
          Expired
        </InverseLabel>
      );
    }

    // Greater than a day, show days and hours
    if (diff > secondsInDay) {
      return (
        <InverseLabel color="#ff9956" bold>
          <span className="hidden-xs">Expires in</span>
          <span className="visible-xs-inline">Exp.</span>{' '}
          {Math.floor(diff / secondsInDay) +
            'd ' +
            Math.floor((diff % secondsInDay) / secondsInHour) +
            'h'}
        </InverseLabel>
      );
    }

    // Greater than an hour, show hours and minutes
    if (diff > secondsInHour) {
      return (
        <InverseLabel color="#d9534f" bold>
          <span className="hidden-xs">Expires in</span>
          <span className="visible-xs-inline">Exp.</span>{' '}
          {Math.floor(diff / secondsInHour) +
            'h ' +
            Math.floor((diff % secondsInHour) / secondsInMinute) +
            'm'}
        </InverseLabel>
      );
    }

    // Greater than a minute, show minutes and seconds
    if (diff > secondsInMinute) {
      return (
        <InverseLabel color="#d9534f" bold>
          <span className="hidden-xs">Expires in</span>
          <span className="visible-xs-inline">Exp.</span>{' '}
          {Math.floor(diff / secondsInMinute) +
            'm ' +
            Math.floor(diff % secondsInMinute) +
            's'}
        </InverseLabel>
      );
    }

    // return in seconds
    return (
      <InverseLabel color="#d9534f" bold>
        <span className="hidden-xs">Expires in</span>
        <span className="visible-xs-inline">Exp.</span> {diff + 's'}
      </InverseLabel>
    );
  }

  render() {
    const { brief, pitch } = this.props;

    const {
      showAcceptPitch,
      showDeclinePitch,
      showContractModal,
      pitchTooLarge,
      fullPitch,
    } = this.state;

    return (
      <div key={`pitch-pitchcomp-containerdiv-${pitch.id}`}>
        <ListGroup>
          <ListGroupItem>
            <Clearfix>
              {pitch.accepted_at === '' && pitch.declined_at === '' && (
                <div className="right ml-">
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      position: 'relative',
                      top: '10px',
                      fontSize: '16px',
                    }}
                  >
                    {this.humanReadableExpiry(pitch.expires_at)}
                  </div>
                </div>
              )}
              {pitch.completed_at !== '' && (
                <span className="pull-right mt-">
                  <InverseLabel className="pull-right" color="#0fe2af">
                    <Icon icon="&#xe60c;" /> Completed
                  </InverseLabel>
                </span>
              )}
              {pitch.completed_at === '' && pitch.accepted_at !== '' && (
                <span className="pull-right mt-">
                  <InverseLabel className="pull-right" color="#0fe2af">
                    <Icon icon="&#xe60c;" />{' '}
                    {this.props.acceptHireAB === 'b' ? 'Hired' : 'Accepted'}
                  </InverseLabel>
                </span>
              )}
              {pitch.completed_at === '' && pitch.declined_at !== '' && (
                <span className="pull-right mt-">
                  <InverseLabel className="pull-right" color="#d9534f">
                    <Icon icon="&#xe60d;" /> Declined
                  </InverseLabel>
                </span>
              )}
              <div className="left mr-">
                <a href={pitch.sender.links.main} className="no-decoration">
                  <Thumbnail
                    thumbnails={pitch.sender.avatars}
                    circle
                    style={{ width: '46px', height: '46px' }}
                  />
                </a>
              </div>
              <div>
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  <a href={pitch.sender.links.main} className="no-decoration">
                    <strong>{pitch.sender.displayname}</strong>
                    <span style={{ marginLeft: '5px' }}>
                      <UserStatusBadges user={pitch.sender} />
                    </span>
                  </a>
                </div>
                <div
                  style={{
                    color: '#aaa',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Submitted <TimeAgo timestamp={pitch.timestamp} />
                </div>
              </div>
            </Clearfix>
          </ListGroupItem>
          {!pitch.deposit_paid_at && (
            <ListGroupItem>
              <Clearfix>
                <div
                  className={
                    pitchTooLarge && !fullPitch ? styles.pitchFade : ''
                  }
                  style={{
                    maxHeight: fullPitch ? '1000px' : '130px',
                    overflow: 'hidden',
                    transition: fullPitch
                      ? 'max-height 1s ease-in-out'
                      : 'max-height 1s cubic-bezier(0, 1, 0, 1)',
                  }}
                >
                  <div id={'pitchWrapper_' + pitch.id}>
                    <Linkify>
                      <p
                        style={{
                          whiteSpace: 'pre-line',
                          overflowWrap: 'break-word',
                          fontSize: '16px',
                          marginBottom: '0px',
                        }}
                      >
                        {pitch.text}
                      </p>
                    </Linkify>
                  </div>
                </div>
                {pitchTooLarge && (
                  <span
                    onClick={() => this.setState({ fullPitch: !fullPitch })}
                    className="text-primary pointer"
                  >
                    {fullPitch ? 'Show less' : 'Show more'}
                  </span>
                )}
              </Clearfix>
            </ListGroupItem>
          )}
          {pitch.amount > 0 || brief.budget > 0 ? (
            <ListGroupItem>
              <Clearfix>
                <div
                  style={{
                    whiteSpace: 'pre-wrap',
                    fontWeight:
                      pitch.deposit && pitch.deposit_paid_at !== ''
                        ? 'normal'
                        : 'bold',
                  }}
                >
                  <span>
                    Freelancer Fee:{' '}
                    <Price
                      currency={brief.currency}
                      amount={pitch.budget > 0 ? pitch.budget : brief.amount}
                    />
                  </span>
                </div>
                {pitch.deposit ? (
                  <div>
                    <div className="mt--" style={{ whiteSpace: 'pre-wrap' }}>
                      <span>
                        Initial payment
                        {pitch.deposit_paid_at !== '' ? ' paid' : ''}:{' '}
                        {pitch.deposit}%{' '}
                      </span>
                    </div>
                    {pitch.deposit_paid_at !== '' ? (
                      <div className="mt--" style={{ whiteSpace: 'pre-wrap' }}>
                        <strong>
                          Total remaining:{' '}
                          <Price
                            currency={brief.currency}
                            amount={
                              pitch.paid_at !== ''
                                ? 0
                                : (pitch.amount > 0
                                    ? pitch.amount
                                    : brief.budget) - pitch.deposit_amount
                            }
                          />
                        </strong>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {pitch.available_at ? (
                  <div className="mt--" style={{ whiteSpace: 'pre-wrap' }}>
                    <span>
                      Available from:{' '}
                      {moment(pitch.available_at).format('MMMM D, YYYY')}
                    </span>
                  </div>
                ) : null}
                {pitch.days_to_complete ? (
                  <div className="mt--" style={{ whiteSpace: 'pre-wrap' }}>
                    <span>
                      Estimated completion time: {pitch.days_to_complete} day
                      {pitch.days_to_complete > 1 ? 's' : ''}
                    </span>
                  </div>
                ) : null}
                {pitch.day_rate ? (
                  <div className="mt--" style={{ whiteSpace: 'pre-wrap' }}>
                    <span>
                      Usual day rate:{' '}
                      <Price
                        currency={pitch.day_rate_currency}
                        amount={pitch.day_rate}
                      />
                    </span>
                  </div>
                ) : null}
              </Clearfix>
            </ListGroupItem>
          ) : null}
          <ListGroupItem>
            <Clearfix>
              {pitch.accepted_at !== '' &&
              (pitch.amount > 0 || brief.budget > 0) ? (
                <Button
                  bsStyle="info"
                  onClick={() => this.setState({ showContractModal: true })}
                  style={{ cursor: 'pointer' }}
                >
                  Agreed Contract
                </Button>
              ) : null}
              <Link
                className={pitch.accepted_at !== '' ? 'pull-right' : ''}
                to={'/messages/' + pitch.sender.username}
              >
                <Button
                  bsStyle={pitch.accepted_at === '' ? 'info' : 'success'}
                  disabled={
                    pitch.accepted_at === '' &&
                    moment().isAfter(pitch.expires_at)
                  }
                >
                  {pitch.accepted_at === '' ? 'Reply' : 'Message'}
                </Button>
              </Link>
              {pitch.accepted_at === '' && pitch.declined_at === '' && (
                <span>
                  <Button
                    className="pull-right"
                    bsStyle="success"
                    onClick={this.showAcceptPitchModal.bind(this)}
                    disabled={moment().isAfter(pitch.expires_at)}
                  >
                    <Icon icon="&#xe60c;" />{' '}
                    {this.props.acceptHireAB === 'b' ? 'Hire' : 'Accept'}
                  </Button>
                  <Button
                    className="pull-right"
                    style={{ marginRight: 10 }}
                    bsStyle="info"
                    onClick={() => this.setState({ showDeclinePitch: true })}
                    disabled={moment().isAfter(pitch.expires_at)}
                  >
                    <Icon icon="&#xe60d;" /> Decline
                  </Button>
                </span>
              )}
            </Clearfix>
          </ListGroupItem>
        </ListGroup>
        <AlertBox
          show={showContractModal}
          onConfirm={() => this.setState({ showContractModal: false })}
          title="Contract and Twine Terms"
          text={
            <p style={{ textAlign: 'left' }}>
              By accepting to work with {pitch.sender.displayname} (the{' '}
              {`<strong>"Seller"</strong>), you (the <strong>"Buyer"</strong>)
              agreed to Twine's`}{' '}
              <a target="_blank" href="/terms">
                Engagement Terms and Conditions
              </a>
              .<br />
              <br />
              {`These terms detail ownership of the work, your obligations as the
              Buyer, the Sellers obligations and your obligation to pay Twine's
              fee.`}
              <br />
              <br />
              <strong>{`"Twine Order Form"`}</strong> is defined as what is
              agreed between the Buyer and Seller on this page and on Twine
              messages.
              <br />
              <br />
              You have also agreed to the{' '}
              <a target="_blank" href="/platform-terms">
                Platform Terms of Use
              </a>
              .
            </p>
          }
          icon="info"
          theme="info"
        />
        <Modal
          show={showDeclinePitch}
          onExit={() => this.setState({ showDeclinePitch: false })}
        >
          <DeclinePitch
            onCancel={() => this.setState({ showDeclinePitch: false })}
            onDecline={this.onDecline.bind(this)}
          />
        </Modal>
        <Modal
          show={showAcceptPitch}
          onExit={() => this.setState({ showAcceptPitch: false })}
        >
          <PaymentModal
            brief={brief}
            pitch={pitch}
            onAccept={this.onAccept.bind(this)}
          />
        </Modal>
      </div>
    );
  }
}
